// @ts-check
import * as Sentry from '@sentry/react';

const SENTRY_DSN = 'https://031b917d147a70c1504549a1ca45f2b2@o4511177284714496.ingest.de.sentry.io/4511177287991376';

export const initSentry = () => {
  // Only initialize in production or if explicitly enabled
  if (process.env.NODE_ENV === 'production' || process.env.REACT_APP_ENABLE_SENTRY === 'true') {
    Sentry.init({
      dsn: SENTRY_DSN,
      environment: process.env.NODE_ENV || 'development',
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: true, // Mask sensitive admin data
          blockAllMedia: false,
        }),
      ],

      // Performance Monitoring
      tracesSampleRate: 1.0,

      // Session Replay
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,

      // Release tracking
      release: process.env.REACT_APP_VERSION || 'development',

      // Custom tags to distinguish from customer frontend
      initialScope: {
        tags: {
          app: 'admin',
          frontend: 'admin-react',
        },
      },

      // Filter out errors from browser extensions
      beforeSend(event, hint) {
        const error = hint.originalException;

        if (error && /** @type {Error} */ (error).message && /** @type {Error} */ (error).message.match(/extension/i)) {
          return null;
        }

        return event;
      },
    });

    console.log('✅ Sentry initialized for Admin Frontend');
  } else {
    console.log('ℹ️ Sentry disabled in development');
  }
};

export default Sentry;
